import { render, staticRenderFns } from "./VoucherAttachment.vue?vue&type=template&id=39f415aa&scoped=true"
import script from "./VoucherAttachment.vue?vue&type=script&lang=js"
export * from "./VoucherAttachment.vue?vue&type=script&lang=js"
import style0 from "./VoucherAttachment.vue?vue&type=style&index=0&id=39f415aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f415aa",
  null
  
)

export default component.exports